export default __webpack_public_path__ + "static/media/grupodpg122.293801e0.svg";